<template>
  <div class="container">
  </div>
</template>
<script>
  export default {
    name: "blank",
    data() {
    },
};
</script>
<style lang="less" scoped>
.container {
  min-height: 100vh;
}
</style>
